import localStorageHelper from '@/helpers/localStorageHelper'

const axios = require('axios')
export default {
  request: function (url, data = {}, method = 'get', params = {}, isFullResponse = false)
  {
    return new Promise((resolve, reject) =>
    {
      const Cookie = require('tiny-cookie')
      const targetCircleClickId = Cookie.get('targetCircleClickId')
      const utmTags = Cookie.get('utmTags')

      if (utmTags) {
        params.utm_tags = utmTags
      }
      if (targetCircleClickId) {
        params.target_circle_click_id = targetCircleClickId
      }
      axios({
        method: method,
        url: process.env.VUE_APP_API_BASE_URL + url,
        data: data,
        params: params
      }).then((response) =>
      {
        let data = response.data
        if (typeof data.data !== 'undefined' && !isFullResponse)
        {
          data = data.data
        }
        resolve(data)
        // Commented based on DEV-704 Affiliate cookie duration
        // if (targetCircleClickId) {
        //   Cookie.remove('targetCircleClickId')
        // }
      }, (rejectReason) =>
      {
        if (rejectReason.response && rejectReason.response.status)
        {
          const error =
            {
              code: rejectReason.response.status,
              message: null,
              redirect: null
            }
          switch (rejectReason.response.status)
          {
            case 401:
              // console.log('401 detected. Logout')
              error.redirect = '/login'
              localStorageHelper.setAsJson('error', error)
              window.location.reload()
              break
            case 422:
              // console.log('422 detected. Logout. Show info')
              if (rejectReason.response.data.message) {
                // show rejectReason.response.data.message
                error.message = rejectReason.response.data.message
                error.redirect = '/'
                localStorageHelper.setAsJson('error', error)
                window.location.reload()
              }
              break
            // case 404:
            //   // // console.log('404 detected. Logout. Show info')
            //   // if (rejectReason.response.data) {
            //   //   // show rejectReason.response.data.message
            //   //   // error.message = rejectReason.response.data
            //   //   error.redirect = '/login'
            //   //   localStorageHelper.setAsJson('error', error)
            //   // }
            //   // window.location.reload()
            //   break
            case 429:
              // Reload page onetime after 5s. Try to refresh.
              if (!localStorageHelper.get('alreadyReloaded'))
              {
                setTimeout(function()
                {
                  localStorageHelper.set('alreadyReloaded', true)
                  location.reload()
                }, 5000)
              }
              break
          }
        }
        this.resolveResponseErrors(rejectReason)
        reject(rejectReason)
      })
    })
  },
  resolveResponseErrors: (rejectReason) =>
  {
    let errorMessage = rejectReason

    if (typeof rejectReason !== 'string')
    {
      if (rejectReason.response && rejectReason.response.data)
      {
        if (rejectReason.response.data.errors)
        {
          if (typeof rejectReason.response.data.errors !== 'string')
          {
            const errors = []

            Object.values(rejectReason.response.data.errors).forEach((item) =>
            {
              if (item)
              {
                if (typeof item === 'string')
                {
                  errors.push(item)
                }
                else if (item.field && item.message)
                {
                  errors.push(item.message)
                }
                else
                {
                  errors.push(Object.values(item).join(' '))
                }
              }
            })

            errorMessage = errors.join(' ')
          }
        }
        else if (rejectReason.response.data.message)
        {
          errorMessage = rejectReason.response.data.message
        }
      }
    }
    console.log('API request got error:', rejectReason)
    return errorMessage
  }
}
